import { Box, Button, Grid, TextField } from '@material-ui/core';
import React from 'react';
import { observer } from 'mobx-react';

const Reviews = observer(({ mainBookFormStore }) => {
  const reviewBlock = (review, index) => {
    return (
      <Box key={index}>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <TextField label='Autor do review'
                       onChange={(e) => mainBookFormStore.handleChangeReview(index, 'author', e.target.value)}
                       value={review.author} error={mainBookFormStore.errors.reviewsFields[index]?.author} />
          </Grid>
          <Grid item xs={6}>
          </Grid>
          <Grid item xs={3} justifyContent='flex-end' display='flex'>
            <Button variant='outlined' color='error' onClick={() => mainBookFormStore.removeReview(index)}>Apagar Review</Button>
          </Grid>
          <Grid item xs={12}>
            <TextField label='Review' onChange={(e) => mainBookFormStore.handleChangeReview(index, 'content', e.target.value)}
                       value={review.content} error={mainBookFormStore.errors.reviewsFields[index]?.content}
                       multiline fullWidth minRows={4}
            />
          </Grid>
        </Grid>
        <br />
        <hr />
        <br />
      </Box>
    );
  };

  return (
    <Box>
      <br />
      <hr />
      <br />
      {mainBookFormStore.formData.reviews.map((review, index) => {
        return reviewBlock(review, index);
      })}
      <Button variant='text' onClick={() => mainBookFormStore.addReview()}>Criar Novo Review</Button>
    </Box>
  );
});

export default Reviews;
